import { AfterViewInit, Component, ElementRef, Injectable, Input, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { Tab } from "src/app/core/services/interface";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { TabNames, common_components_map } from "src/app/core/services/constants";
import { DomSanitizer } from "@angular/platform-browser";
import Axios, { AxiosResponse, AxiosError } from "axios";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-web-view",
  templateUrl: "./web-view.component.html",
  styleUrls: ["./web-view.component.scss"],
})
@Injectable()
export class WebViewComponent implements OnInit, AfterViewInit,OnDestroy {
  // bread crumb items

  @Input() fontResize = false;
  @Input() fontSmaller = false;

  updateBuilderComponentSubscribtion: any;
  tabNames = TabNames;
  imageLg: string;
  imageSm: string;
  image: string;
  icon: string;
  icon_ios: string;
  title: string;
  like: any;
  reply: any;
  view: any;
  share: any;
  imageL = false;
  imageS = false;
  web_url: any;
  web_html: any;
  tab: Tab;
  idHtml: string;
  emptyImage: string;


  @Input() inputTab: Tab;
  constructor(
    private mdw: MiddlwareService,
    private ws: WebsocketService,
    private indexDBService: IndexDBService,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2, private el: ElementRef
  ) {}

  ngOnInit() {
    this.idHtml = this.mdw.makeRef(16);
    this.emptyImage = this.mdw.mobileTheme(this.inputTab).emptyImage

    this.updateBuilderComponentSubscribtion =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (
          (data &&
          common_components_map[data.tab.module].type ===
            TabNames.WEBVIEW) || (this.inputTab && common_components_map[this.inputTab.module].type == TabNames.WEBVIEW)
        ) {
          if (this.inputTab) {
            this.tab = { ...this.inputTab };
          } else {
            this.tab = { ...data.tab };
          }
          if (this.tab.web_view && this.tab.web_view.wv_url) {

            this.image = this.mdw.mobileTheme(this.tab).emptyImage

            this.web_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.tab.web_view.wv_url);
            this.image = this.tab.image_url;
            //when receiving tab webview you must check and generate the image.
          }else if(this.tab.web_view && this.tab.web_view.wv_html){
            this.image = this.tab.image_url;
            //when receiving tab webview HTML you must check and generate the image.
          }

          this.image = this.tab.image_url ? this.tab.image_url : null;
        }
      });


  }


  ngAfterViewInit() {
    // HTML content with script tag
    // setTimeout(()=>{
    //   // Add the widget HTML using innerHTML
    //   console.log(this.idHtml,this.el.nativeElement.querySelector('#widgetContainer' + this.idHtml));
    //   this.el.nativeElement.querySelector('#widgetContainer' + this.idHtml).innerHTML = this.tab.web_view.wv_html;

    //   // Find the inserted script tag
    //   const script = this.el.nativeElement.querySelector('script');

    //   // Create a new script element and set its source (src) to the one in the HTML
    //   const newScript = this.renderer.createElement('script');
    //   this.renderer.setAttribute(newScript, 'type', 'text/javascript');
    //   this.renderer.setAttribute(newScript, 'src', script.src);

    //   // Append the new script to the body or head to execute it
    //   this.renderer.appendChild(document.body, newScript);
    // }, 3000)


  }


  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscribtion) {
      this.updateBuilderComponentSubscribtion.unsubscribe();
    }
  }
}
